
import { useState } from 'react';

export default function GallerySection() {
  const [activeIndex, setActiveIndex] = useState(0);

  const screens = [
    {
      title: 'Home',
      description: 'Your portfolio at a glance',
      content: (
        <div className="p-4 lbx">
          <div className="text-center mb-4">
            <p className="text-xs text-gray-500">Total Balance</p>
            <h3 className="text-2xl  font-bold text-gray-900">$12,458.32</h3>


            <p className="ttlp fz14 ">Account 1(Imported) <svg width="21" height="19" viewBox="0 0 21 19" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M16.1905 6L10.0952 12.0952L4 6" stroke="black" stroke-width="1.5" stroke-linecap="square" stroke-linejoin="round" />
            </svg>
            </p>
            <p className="copy_n fz12"><span>0xcaB7D5E...dD5...</span> <a href="" >
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M11.0477 9.52414V4.1908C11.0477 3.34922 10.3655 2.66699 9.52389 2.66699H4.19056C3.34898 2.66699 2.66675 3.34922 2.66675 4.1908V9.52414C2.66675 10.3657 3.34898 11.0479 4.19056 11.0479H9.52389C10.3655 11.0479 11.0477 10.3657 11.0477 9.52414Z" stroke="#979797" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M4.95239 11.0484V11.8103C4.95239 12.6518 5.63463 13.3341 6.4762 13.3341H11.8095C12.6511 13.3341 13.3333 12.6518 13.3333 11.8103V6.47693C13.3333 5.63536 12.6511 4.95312 11.8095 4.95312H11.0476" stroke="#979797" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </a></p>
          </div>
          <div className="button_gp">

            <button className="btn_s "><svg width="15" height="13" viewBox="0 0 15 13" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M10.0866 0.373698L5.60266 11.5045M5.60266 11.5045L0.817188 4.71825M5.60266 11.5045L13.9208 9.65741" stroke="#E84343" stroke-width="2" />
            </svg> Send
            </button>
            <span className='btn_sx'><svg xmlns="http://www.w3.org/2000/svg" width="27" height="22" viewBox="0 0 27 22" fill="none">
              <path d="M1 6.20836V5C1 2.79086 2.79086 1 5 1H22C24.2091 1 26 2.79086 26 5V6.20836" stroke="white" stroke-width="2" />
              <path d="M1 15.5836V16.792C1 19.0011 2.79086 20.792 5 20.792H22C24.2091 20.792 26 19.0011 26 16.792V15.5836" stroke="white" stroke-width="2" />
              <path d="M1 11.417H26" stroke="white" stroke-width="2" />
            </svg></span>
            <button className="btn_s"><svg xmlns="http://www.w3.org/2000/svg" width="15" height="13" viewBox="0 0 15 13" fill="none">
              <path d="M4.05088 12.2513L8.53479 1.12051M8.53479 1.12051L13.3203 7.90675M8.53479 1.12051L0.216682 2.96759" stroke="#24B664" stroke-width="2" />
            </svg>Receive</button>
          </div>

          <p className="sct">Scan to connect</p>
          {/* <div className="flex justify-center gap-3 mb-4">
            <div className="w-10 h-10 bg-[#4C6FFF] rounded-full flex items-center justify-center">
              <i className="ri-arrow-up-line text-white"></i>
            </div>
            <div className="w-10 h-10 bg-[#00D0A3] rounded-full flex items-center justify-center">
              <i className="ri-arrow-down-line text-white"></i>
            </div>
          </div> */}
          <div className="space-y-2">
            <div className="flex items-center justify-between p-2 bg-gray-50 rounded-lg">
              <div className="flex items-center gap-2">
                <div className="w-6 h-6 bg-orange-500 rounded-full"></div>
                <span className="text-xs font-medium">BTC</span>
              </div>
              <span className="text-xs">$8,234</span>
            </div>
            <div className="flex items-center justify-between p-2 bg-gray-50 rounded-lg">
              <div className="flex items-center gap-2">
                <div className="w-6 h-6 bg-blue-500 rounded-full"></div>
                <span className="text-xs font-medium">ETH</span>
              </div>
              <span className="text-xs">$4,224</span>
            </div>
          </div>
        </div>
      ),
    },
    {
      title: 'Send',
      description: 'Send crypto anywhere',
      content: (
        <div className="p-4">
          <h3 className="text-sm font-semibold text-gray-900 mb-4">Send Tokens</h3>
          <div className="space-y-3">
            <div className="bg-gray-50 rounded-lg p-3">

              <p className="text-xs font-mono text-gray-700 truncate">bc1qxy2kgdygjrsqtzq2n0yrf2493p83kkfjhx0wlh</p>
            </div>
            <div className="space-y-2">
              <div className="flex items-center justify-between p-2 bg-gray-50 rounded-lg">
                <div className="flex items-center gap-2">
                  <div className="w-6 h-6 bg-orange-500 rounded-full"></div>
                  <span className="text-xs font-medium">BTC</span>
                </div>
                <span className="text-xs">$8,234</span>
              </div>
              <div className="flex items-center justify-between p-2 bg-gray-50 rounded-lg">
                <div className="flex items-center gap-2">
                  <div className="w-6 h-6 bg-blue-500 rounded-full"></div>
                  <span className="text-xs font-medium">ETH</span>
                </div>
                <span className="text-xs">$4,224</span>
              </div>
            </div>
          </div>
          <button className="w-full bg-[#4C6FFF] text-white text-sm py-2 rounded-lg mt-3 cursor-pointer whitespace-nowrap">
            Confirm Send
          </button>
        </div>
      ),
    },
    {
      title: 'Receive',
      description: 'Share your QR code',
      content: (
        <div className="p-4 text-center">
          <h3 className="text-sm font-semibold text-gray-900 mb-4">Receive Tokens</h3>

          <img src="/img/recive.png" alt="" />

        </div>
      ),
    },
    {
      title: 'Transaction',
      description: 'Transaction details',
      content: (
        <div className="p-4">
          <img src="/img/transaction.png" alt="" />

        </div>
      ),
    },
  ];

  return (
    <section className="py-16 lg:py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 lg:mb-16">
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
            Take a closer look
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Clean, intuitive screens designed for everyday use.
          </p>
        </div>

        {/* Screen Selector */}
        <div className="flex justify-center gap-2 mb-8 flex-wrap">
          {screens.map((screen, index) => (
            <button
              key={index}
              onClick={() => setActiveIndex(index)}
              className={`px-4 py-2 rounded-full text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${activeIndex === index
                ? 'bg-[#4C6FFF] text-white'
                : 'bg-white text-gray-600 hover:bg-gray-100'
                }`}
            >
              {screen.title}
            </button>
          ))}
        </div>

        {/* Phone Display */}
        <div className="flex justify-center">
          <div className="relative">
            <div className="w-64 sm:w-72 bg-gray-900 rounded-[2.5rem] p-2.5 shadow-2xl">
              <div className="bg-white rounded-[2rem] overflow-hidden min-h-[400px]">
                {/* Status Bar */}
                <div className="bg-gray-100 px-4 py-2 flex justify-between items-center">
                  <span className="text-[10px] font-medium text-gray-600">9:41</span>
                  <div className="flex items-center gap-1">
                    <i className="ri-signal-wifi-3-line text-[10px] text-gray-600"></i>
                    <i className="ri-battery-2-charge-line text-[10px] text-gray-600"></i>
                  </div>
                </div>

                {/* Screen Content */}
                {screens[activeIndex].content}
              </div>
            </div>

            {/* Caption */}
            <div className="text-center mt-6">
              <h3 className="font-semibold text-gray-900">{screens[activeIndex].title}</h3>
              <p className="text-sm text-gray-500">{screens[activeIndex].description}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
